import axios from 'axios'
import router from "../router"
import {Cookies} from 'quasar-framework'
import {mapGetters} from "vuex";

export default {
    metaInfo() {
        return {
            title: this.content && this.content.item ? this.content.item.title : this.$T('loading...')
        }
    },
    data() {
        return {
            content: null,
            content_url: null,
            portal_base: null
        }
    },
    created() {
        // fetch the content when the view is created and the content is already being observed
        this.fetchContent()
        console.log(this.$route.path)
        if (this.$route.path !== '/pages/policy') {
            document.getElementsByClassName('q-layout-header')[0].style.display = "block"
        }
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchContent'
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        routePath() {
            return this.$route.path
        },

        tabs() {
            let tabs = {}
            if (this.content.item.body)
                tabs[this.$T('detail')] = {}
            if (this.content.item.how_to_play)
                tabs[this.$T('how to play')] = {}
            tabs[this.$T('comments')] = {}
            if (Object.keys(this.content.related).length > 0)
                tabs[this.$T('related')] = this.content.related
            return tabs
        }
    },
    methods: {
        fetchContent() {
            this.$loading(true)
            //axios.get(`${config.appUrl}/api${this.routePath}`)
            this.portal_base = Cookies.get('portal')
            let userId = this.user ? this.user.id : null
            if (!this.portal_base) {
                axios.get(`${config.PortalBase}/get-portals`)
                    .then((response) => {
                        for (const responseKey in response.data) {
                            if (response.data[responseKey].portal.url === config.appUrlPortal
                                || response.data[responseKey].portal.url === config.appUrlPortal+'/') {
                                this.portal_base = response.data[responseKey].portal.id
                                Cookies.set('portal', this.portal_base, {expires: 1,path: '/'})
                            }
                        }
                    }).finally(() => {
                    axios.get(`${config.appUrl}/${this.portal_base}/${userId}${this.routePath}?lang=${Cookies.get('locale')}`)
                        .then(({data}) => {
                            this.content = data.content
                            this.checkSubscription(data.content.item.content_id);
                        })
                        .catch(error => {
                            if (error.response && error.response.status === 404) {
                                Cookies.remove('portal')
                                router.replace('/404')
                            }
                            this.$loading(false)
                        })
                })
            } else {
                axios.get(`${config.appUrl}/${this.portal_base}/${userId}${this.routePath}?lang=${Cookies.get('locale')}`)
                    .then(({data}) => {
                        this.content = data.content
                        this.checkSubscription(data.content.item.content_id);
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 404) {
                            Cookies.remove('portal')
                            router.replace('/404')
                        }
                        this.$loading(false)
                    })
            }
        },

        checkSubscription(contentId) {
            axios.get(`${config.appUrl}/${this.portal_base}/${userId}/subscription/video/${contentId}/check`)
                .then(({data}) => {
                    this.content_url = data.url;
                    this.$loading(false)
                })
                .catch(error => {
                    this.$loading(false)
                })
        },
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/content.js